// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Qo-z","selected":"Ro-z"};